import { createAction, props } from '@ngrx/store';
import {
  RangoSalarialPerfil,
  CreateRangoSalarialPerfilRequest,
  UpdateRangoSalarialPerfilRequest
} from '../models/rango-salarial-perfil.interface';

// Load actions
export const loadRangosSalariales = createAction(
  '[Rango Salarial Perfil] Load Rangos Salariales',
  props<{ force?: boolean }>()
);

export const loadRangosSalarialesSuccess = createAction(
  '[Rango Salarial Perfil] Load Rangos Salariales Success',
  props<{ rangosSalariales: RangoSalarialPerfil[] }>()
);

export const loadRangosSalarialesFailure = createAction(
  '[Rango Salarial Perfil] Load Rangos Salariales Failure',
  props<{ error: string }>()
);

// Create actions
export const createRangoSalarialPerfil = createAction(
  '[Rango Salarial Perfil] Create Rango Salarial Perfil',
  props<{ rangoSalarial: CreateRangoSalarialPerfilRequest }>()
);

export const createRangoSalarialPerfilSuccess = createAction(
  '[Rango Salarial Perfil] Create Rango Salarial Perfil Success',
  props<{ rangoSalarial: RangoSalarialPerfil }>()
);

export const createRangoSalarialPerfilFailure = createAction(
  '[Rango Salarial Perfil] Create Rango Salarial Perfil Failure',
  props<{ error: string }>()
);

// Update actions
export const updateRangoSalarialPerfil = createAction(
  '[Rango Salarial Perfil] Update Rango Salarial Perfil',
  props<{ id: number; rangoSalarial: UpdateRangoSalarialPerfilRequest }>()
);

export const updateRangoSalarialPerfilSuccess = createAction(
  '[Rango Salarial Perfil] Update Rango Salarial Perfil Success',
  props<{ rangoSalarial: RangoSalarialPerfil }>()
);

export const updateRangoSalarialPerfilFailure = createAction(
  '[Rango Salarial Perfil] Update Rango Salarial Perfil Failure',
  props<{ error: string }>()
);

// Selection actions
export const selectRangoSalarialPerfil = createAction(
  '[Rango Salarial Perfil] Select Rango Salarial Perfil',
  props<{ rangoSalarial: RangoSalarialPerfil | null }>()
);

// Clear actions
export const clearRangoSalarialPerfilError = createAction('[Rango Salarial Perfil] Clear Error');

export const clearRangoSalarialPerfilSelection = createAction(
  '[Rango Salarial Perfil] Clear Selection'
);
